export default __webpack_public_path__ + "static/media/three_dots.ad785af3.svg";